import React from 'react'
import styleObj from './style.module.scss'

export default function Loading(props) {
  return (
    <div className={styleObj['loading-wrap']}>
      <div className={styleObj['page-loading']}>
        <div className={styleObj['loading-wrap']}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  )
}
